import PropTypes from 'prop-types';

const productType = {
  arrival: PropTypes.shape({
    arrival_time: PropTypes.string,
    name: PropTypes.string,
  }),
  departure: PropTypes.shape({
    departure_time: PropTypes.string,
    name: PropTypes.string,
  }),
  label: PropTypes.string,
};

const productShape = PropTypes.shape(productType);

const serviceShape = PropTypes.shape({
  ...productType,
  date: PropTypes.string,
});

const ferryShape = PropTypes.shape({
  date: PropTypes.string,
  products: PropTypes.arrayOf(productShape),
});

const vehicleShape = PropTypes.shape({
  name: PropTypes.string,
  icon: PropTypes.string.isRequired,
  price: PropTypes.string.isRequired,
  attachments: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      count: PropTypes.number,
    })
  ),
});

const passengerShape = PropTypes.shape({
  name: PropTypes.string.isRequired,
  count: PropTypes.number.isRequired,
  price: PropTypes.number,
  adjustments: PropTypes.arrayOf(
    PropTypes.shape({
      description: PropTypes.string.isRequired,
      amount: PropTypes.number.isRequired,
    })
  ),
});

const optionalExtrasShape = PropTypes.arrayOf(
  PropTypes.shape({
    name: PropTypes.string.isRequired,
    count: PropTypes.number.isRequired,
    price: PropTypes.number,
  })
);

const customerFacingAdjustmentShape = PropTypes.shape({
  category_id: PropTypes.number,
  display_name: PropTypes.string,
  total: PropTypes.number.isRequired,
});

export const FerryViewPropType = {
  onlyShowInfo: PropTypes.bool,
  ferry: PropTypes.shape({
    price: PropTypes.number,
    commissionPrice: PropTypes.number,
    departureFerry: ferryShape,
    returnFerry: ferryShape,
    services: PropTypes.arrayOf(serviceShape),
    passengers: PropTypes.arrayOf(passengerShape),
    vehicles: PropTypes.arrayOf(vehicleShape),
    optionalExtras: optionalExtrasShape,
    customerFacingAdjustments: PropTypes.arrayOf(customerFacingAdjustmentShape),
  }),
  actions: PropTypes.shape({
    editFerry: PropTypes.func,
    removeFerry: PropTypes.func,
  }),
  isDeletingReservation: PropTypes.bool,
};

export const FerryDetailPropType = {
  detail: ferryShape,
  title: PropTypes.string,
  altIcon: PropTypes.string,
};
